var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('div',{ref:"talkjs",staticStyle:{"width":"100%","height":"80vh"}},[_c('i',[_vm._v("Loading chat...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }